import { api } from "@/api/client";

export type Asset = {
  id: string;
  tenant_id: string;
  name: string;
  asset_type: string;
  category: string;
  description: string | null;
  criticality: number;
  status: string;
  location: string | null;
  parent_id: string | null;
  asset_metadata: Record<string, unknown>;
  tags: string[];
  created_by: string | null;
  created_at: string;
  updated_at: string;
  propagated_risk: string | null;
  direct_risk: string | null;
};

export type AssetCreate = {
  name: string;
  asset_type: string;
  category: string;
  description?: string | null;
  criticality?: number;
  status?: string;
  location?: string | null;
  parent_id?: string | null;
  asset_metadata?: Record<string, unknown>;
  tags?: string[];
};

export type AssetUpdate = Partial<AssetCreate>;

export type AssetListParams = {
  limit?: number;
  offset?: number;
  category?: string;
  asset_type?: string;
  status?: string;
  parent_id?: string;
  search?: string;
};

function toSearchParams(params: AssetListParams | undefined): URLSearchParams | undefined {
  if (!params) return undefined;
  const sp = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    const str = String(value);
    if (str === "" || str === "undefined") continue;
    sp.append(key, str);
  }
  return sp;
}

export async function listAssets(params?: AssetListParams): Promise<Asset[]> {
  return api.get("assets", { searchParams: toSearchParams(params) }).json<Asset[]>();
}

export async function getAsset(id: string): Promise<Asset> {
  return api.get(`assets/${id}`).json<Asset>();
}

export async function createAsset(payload: AssetCreate): Promise<Asset> {
  return api.post("assets", { json: payload }).json<Asset>();
}

export async function updateAsset(id: string, payload: AssetUpdate): Promise<Asset> {
  return api.patch(`assets/${id}`, { json: payload }).json<Asset>();
}

export async function deleteAsset(id: string): Promise<void> {
  await api.delete(`assets/${id}`);
}
